import React from 'react';
import './About.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

const About = () => {
  return (
    <div className=" flex flex-col min-h-screen">
      <Navbar />
      <div className='about-container'>
        <div className="about-header">
          {/* <div className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>About</span>
          </div> */}

          <div className="header-content">
            <div className="title-section">
              <div className="subtitle">
                <span>通过专业数据洞察赋能行业变革</span>
              </div>
              <h1 className="main-title">
                关于河北视动科技
              </h1>
            </div>

            <div className="description">
              <p className="company-intro">
                河北视动科技是一家专注于大数据技术与软件服务的创新型企业。
                公司致力于通过前沿的大数据分析技术、机器学习算法和可视化手段，
                为客户提供高效、智能、可定制化的一站式数字化解决方案。
                总部位于河北，拥有一支由资深数据工程师、软件架构师、
                行业专家和顾问组成的专业团队，服务客户遍及政企、金融、
                房产、制造等多个领域。
              </p>
            </div>
          </div>
        </div>

        <div className="about-image">
          <img src="/images/about/image.png" alt="数据分析展示" />
        </div>
      </div>

      <div className="mission-vision-section">
        <div className="mission-vision-image">
          <img src="/images/about/image2.png" alt="数据分析技术" />
        </div>
        
        <div className="mission-vision-content">
          <div className="mission-box">
            <h2>企业使命</h2>
            <p>
              我们深耕数据技术与行业应用，为客户打造智能化、可视化、可落地的数字化解决方案。
              通过核心大数据产品，为企业实现数据高效整合、深度挖掘与价值转化，赋能高层决策与业务创新，
              让客户在竞争激烈的市场中保持稳健发展。
            </p>
          </div>

          <div className="vision-box">
            <h2>企业愿景</h2>
            <p>
              河北视动科技希望通过不断的技术迭代与产品创新，面向市场提供专业、精准、可扩展的智慧数据解决方案。
              无论是房产投资分析、企业投资与风险管理，还是多行业的数据可视化与分析场景，
              我们都致力于引领数字化潮流，打造大数据到闭环软件生态体系。
            </p>
          </div>
        </div>
      </div>

      <div className=' mt-auto' style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default About; 